<script>
import CrudListVue from '@/app/arch/components/crud/CrudList.vue';
import StatementsRequest from 'Modules/contacard/reports/statements/StatementsRequest';
import DataTableCurrencyColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableCurrencyColumn.vue';
import DataTableCpfCnpjColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableCpfCnpjColumn.vue';
import DataTableBooleanColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableBooleanColumn.vue';
import DataTableDateColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableDateColumn.vue';
import DateMixin from '@/app/arch/mixins/DateMixin';
import StatementOperationColumnVue from './components/StatementOperationColumn.vue';
import StatementTypeColumnVue from './components/StatementTypeColumn.vue';
import StatementOperationTypeColumnVue from './components/StatementOperationTypeColumn.vue';
import StatementPaymentMethodColumnVue from './components/StatementPaymentMethodColumn.vue';

export default {
  name: 'StatementsCrudList',
  extends: CrudListVue,
  mixins: [DateMixin],
  data: () => ({
    requestClass: StatementsRequest,
    hideEdit: true,
    hideDelete: true,
    headers: [
      {
        text: 'Cliente',
        value: 'clientName',
      },
      {
        text: 'Documento',
        value: 'clientDocument',
        component: DataTableCpfCnpjColumnVue,
      },
      {
        text: 'Origem',
        value: 'origin',
      },
      {
        text: 'Destino',
        value: 'destination',
      },
      {
        text: 'Operação',
        value: 'transactionOperation',
        component: StatementOperationColumnVue,
      },
      {
        text: 'Tipo',
        value: 'type',
        component: StatementTypeColumnVue,
      },
      {
        text: 'Tipo de operação',
        value: 'operationType',
        component: StatementOperationTypeColumnVue,
      },
      {
        text: 'Valor',
        value: 'value',
        component: DataTableCurrencyColumnVue,
      },
      {
        text: 'Método de pagamento',
        value: 'paymentMethod',
        component: StatementPaymentMethodColumnVue,
      },
      {
        text: 'Taxa e comissão adicionada',
        value: 'taxAndCommissionAddedToMainValue',
        component: DataTableBooleanColumnVue,
      },
      {
        text: 'Descrição',
        value: 'description',
        toast: true,
      },
      {
        text: 'Data da transação',
        value: 'createdAt',
        component: DataTableDateColumnVue,
      },
    ],
  }),
  computed: {
    getDefaultParams() {
      return {
        OrderByDesc: 'createdAt',
      };
    },
  },
  methods: {
    prepareRequest(params) {
      return this.requestClass.list(this.setDefaultParams(params));
    },
    setDefaultParams(params = {}) {
      return {
        ...this.getDefaultParams,
        ...params,
      };
    },
  },
};
</script>
